import { useCustomMutation } from '@refinedev/core';

export type EmailDocumentType = 'MEETING_NOTE' | 'MEETING_AGENDA' | 'DATA_EXPORT';

type EmailContentResponse = {
  body: string;
};

type GenerateEmailContentParams = {
  clientId: string;
  documentId: string;
  documentType: EmailDocumentType;
};

export const useGenerateEmailContent = () => {
  const { mutateAsync, isLoading, isSuccess, isError, error, data } =
    useCustomMutation<EmailContentResponse>();

  const generateEmailContent = async ({
    clientId,
    documentId,
    documentType,
  }: GenerateEmailContentParams) => {
    const result = await mutateAsync({
      method: 'post',
      url: `clients/${clientId}/documents/${documentId}/email-content?document_type=${documentType}`,
      values: {},
    });
    return result.data;
  };

  return {
    generateEmailContent,
    isLoading,
    isSuccess,
    isError,
    error,
    emailBody: data?.data?.body,
  };
};
